import { Reveal } from "./Reveal";
import { TOOLS } from "../data/tools";

const Row = ({ items, reverse }) => (
  <div className="relative overflow-hidden py-3 [mask-image:linear-gradient(90deg,transparent,#000_12%,#000_88%,transparent)]">
    <div className={`${reverse ? "marquee-track-reverse" : "marquee-track-slow"} flex w-max items-center gap-4`}>
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-4">
          {items.map((tool) => (
            <div
              key={`${copy}-${tool.slug}`}
              data-testid={`tool-pill-${tool.slug}`}
              className="group flex items-center gap-3 whitespace-nowrap rounded-full border border-white/[0.08] bg-[#0d1219]/80 px-5 py-3 backdrop-blur-sm transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-[#007BFF]/60 hover:shadow-[0_0_30px_rgba(0,123,255,0.35)]"
            >
              <span
                className="flex h-9 w-9 items-center justify-center rounded-full border"
                style={{ borderColor: `${tool.color}55`, backgroundColor: `${tool.color}1a` }}
              >
                <img src={`/logos/color/${tool.slug}.svg`} alt={tool.name} className="h-4 w-4 opacity-90 transition-opacity duration-300 group-hover:opacity-100" loading="lazy" />
              </span>
              <span className="text-sm font-medium text-slate-300 transition-colors duration-300 group-hover:text-white">{tool.name}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const ToolsMarquee = () => {
  const half = Math.ceil(TOOLS.length / 2);
  return (
    <section id="ferramentas" data-testid="tools-section" className="relative overflow-hidden border-y border-white/5 bg-[#080b11]/75 py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-slate-500" data-testid="tools-eyebrow">Ecossistema</p>
          <h2 className="mt-4 max-w-2xl text-2xl font-semibold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl" data-testid="tools-heading">
            Ferramentas que <span className="text-[#3a9bff]">integramos</span> ao seu negócio
          </h2>
          <p className="mt-4 max-w-xl text-base text-slate-400" data-testid="tools-subtext">
            De agentes de IA a canais de atendimento, conectamos o que você já usa com o que vai fazer você crescer.
          </p>
        </Reveal>
      </div>
      <div className="mt-12 space-y-2">
        <Row items={TOOLS.slice(0, half)} />
        <Row items={TOOLS.slice(half)} reverse />
      </div>
    </section>
  );
};
